module.exports = __webpack_public_path__ + "img/4_51.180d2afb.png";